var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{staticStyle:{"margin-right":"4px"},attrs:{"medium":"","color":"grey darken-2"}},[_vm._v(" mdi-tune ")]),_c('v-icon',{attrs:{"color":"grey"}},[_vm._v(" mdi-message-text ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }